import vue from "vue";
import commonPop from "@/components/commonPop.vue";

// 返回一个 扩展实例构造器
const PopUpConstructor = vue.extend(commonPop);

function showPopUp(popData) {
    // 关闭按钮，蒙层关闭，esc关闭处理s 属性提前处理
    const beferHandleArr = [
        {key:'showClose',value:true},
        {key:'closeOnClickModal',value:true},
        {key:'closeOnPressEscape',value:true},
        {key:'showFooter',value:true}
    ]
    beferHandleArr.forEach(item=>{
        !popData.hasOwnProperty(item.key) && (popData[item.key] = item.value)
    })
  // 实例化一个 commonPop.vue
  const popUpDom = new PopUpConstructor({
    el: document.createElement("div"),
    data() {
      return {
        show: true,
        width:popData.width || '50vw',
        showFooter:popData.showFooter,
        footerType: popData.footerType || "center",
        title:popData.title || "title",
        cancleText: popData.cancleText ||"取消",
        confirmText: popData.confirmText || "确认",
        showClose: popData.showClose ,
        closeOnClickModal: popData.showClose,
        closeOnPressEscape: popData.showClose,
        contentText: popData.contentText || '',
        zIndex:popData.zIndex || 2001,
      };
    },
    methods: {
        cancleCallback: function () {
        this.show = false;
        popData.cancleCallback && popData.cancleCallback();
      },
      confirmCallback: function () {
        this.show = false;
        popData.confirmCallback && popData.confirmCallback();
      },
    },
  });

  // 把 实例化的 popUp.vue 添加到 body 里
  document.body.appendChild(popUpDom.$el);
  return popUpDom;
}

// 注册为全局组件的函数
// function registryPopUp() {
//   vue.prototype.$popUp = showPopUp;
// }

// export default registryPopUp;

// 注册为全局组件的函数
vue.prototype.$popUp = showPopUp;
